import React from "react";

export default function BedForm(props) {
  return (
    <>
      <div
        id={`${
          typeof props.id !== "undefined" ? props.id : "responsive-modal"
        }`}
        className="modal fade bs-example-modal-lg"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        style={{ display: "none" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="myLargeModalLabel">
                {props.title ?? ""}
              </h4>
              <button
                type="button"
                className={`${
                  typeof props.close !== "undefined"
                    ? props.close
                    : "closeModal"
                }`}
                id={`${
                  typeof props.close !== "undefined" ? props.close : "close"
                }`}
                data-dismiss="modal"
                aria-hidden="true"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="mb-3 form-group col-md-12">
                  <label className="form-label">Bed Name</label>
                  <input
                    type="text"
                    name="bedName"
                    className="form-control"
                    id="bedName"
                    value={props.bedFormData.bedName}
                    onChange={props.onEditBed}
                    placeholder="Bed Name"
                  />
                </div>
                <div className="mb-3 form-group col-md-6">
                  <label className="form-label">Room</label>
                  <select
                    className="form-control"
                    name="roomID"
                    id="roomID"
                    value={props.bedFormData.roomID}
                    onChange={props.onEditBed}
                  >
                    <option value="">Select Room</option>
                    {props.roomList.length > 0 &&
                      props.roomList.map((item, index) => {
                        return (
                          <option key={index} value={item.roomID}>
                            {item.roomName}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="mb-3 form-group col-md-6">
                  <label className="form-label">Room Status</label>
                  <select
                    className="form-control"
                    name="status"
                    id="status"
                    value={props.bedFormData.status}
                    onChange={props.onEditBed}
                  >
                    <option value="">Select Status</option>
                    <option value="1">Available</option>
                    <option value="0">Not Available</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default waves-effect"
                data-dismiss="modal"
              >
                Close
              </button>
              {props.IsFormLoading ? (
                <button type="button" className="btn btn-primary ms-auto">
                  <span>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    />{" "}
                    Please wait...
                  </span>
                </button>
              ) : (
                <button
                  type="button"
                  onClick={props.onSubmitBed}
                  className="btn btn-danger waves-effect waves-light"
                >
                  {props.btn ?? "submit"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
